module.exports = __webpack_public_path__ + "static/media/stop_button.65416413.svg";